module.exports = __webpack_public_path__ + "img/60x32x60-Kit.ff0c66ee.png";